import { environmentService } from '../stores/store';

export {};

type ToCurrencyStringOptions = {
  excludePrefix?: boolean;
};

declare global {
  interface Number {
    ToCurrencyString: (options?: ToCurrencyStringOptions) => string;
  }
}

// Reason this is not an arrow function is to ensure that the context of 'this' is preserved on its usage on line 15
// \xA0 is a non breaking space that prevents currency being broken by newlines
Number.prototype.ToCurrencyString = function (options?: ToCurrencyStringOptions): string {
  const currencyCountryCode = environmentService.getCurrencyCode();
  return new Intl.NumberFormat('en-Us', {
    style: options?.excludePrefix ? 'decimal' : 'currency',
    currency: currencyCountryCode,
    minimumFractionDigits: 2,
    currencyDisplay: 'narrowSymbol'
  })
    .format(this.valueOf())
    .replace(/,/g, '\xA0')
    .replace(/[\u202F\u00A0]/g, '\xA0');
};
